import React from 'react'

import {
  InfoContainer,
  Image,
  Name,
  BoxLine,
  IconSocial,
  NameContainer
} from './styles'

import linkedin from '../../../../assets/linkedin.svg'
import github from '../../../../assets/github.png'

const Info = () => {
  return (
    <InfoContainer>
      <Image />
      <NameContainer>
        <Name>Juan</Name>
        <Name>Aragón</Name>
        <BoxLine />
        <div>
          <a href="https://www.linkedin.com/in/juan-esteban-aragon-montealegre/" target="blank">
            <IconSocial src={linkedin} />
          </a>
          <a href="https://github.com/aragonesteban" target="blank">
            <IconSocial src={github} />
          </a>
        </div>
      </NameContainer>
    </InfoContainer>
  )
}

export default Info